import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ConfigService } from './config/config.service';
import { PasswordStorageService } from './password-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  isAuthenticatedEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
  private baseUrlApi: string;

  constructor(
    private client: HttpClient,
    private passwordStorageService: PasswordStorageService,
    private configService: ConfigService
  ) {
    this.configService.loadConfigFromJson().subscribe(() => {
      this.baseUrlApi = this.configService.config.urlApi;
      console.log(this.baseUrlApi);

    });
  }

  isAuthenticated(): Observable<boolean> {
    return this.client.head(`${this.baseUrlApi}/api/c/authentication/isAuthenticated`).pipe(
      map(() => true),
      catchError(() => of(false)),
      tap(isAuthenticated => this.isAuthenticatedEvent.next(isAuthenticated))
    );
  }

  disconnect() {
    this.passwordStorageService.storePassword(undefined);
    this.isAuthenticatedEvent.next(false);
  }

  connect(password: string) {
    this.passwordStorageService.storePassword(password);
  }
}
